import Axios from "axios"

export default {

  /**
   * 
   * @param {*} keyword 
   * @param {*} contract_start_date 
   * @param {*} contract_end_date 
   * @param {*} page 
   */
  listPage(
    keyword,
    contract_start_date,
    contract_end_date,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/contract/page`, {
      params: {
        keyword,
        contract_start_date,
        contract_end_date,
        page
      }
    });
  },

  /**
   * 详情
   * @param {*} contractId 
   */
  info(
    contractId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/contract/${contractId}`);
  }

}